
import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { Action, State } from "vuex-class";

@Component
export default class ModalVerifyAcceptAll extends Vue {
  /* VUEX */

  // ACTION
  @Action('actionApproveAllCandidate', {namespace: 'candidate'})
  private actionApproveAllCandidate: any;
  // STATE

  /* PROP */
  @Prop({default: false})
  private isShow: boolean;

  /* INITIALIZATION */

  /* METHOD */
  private clickSubmit() {
    this.actionApproveAllCandidate({
      listener: () => {
        this.$emit("onConfirmed", true);
        this.$emit("update:isShow", false);
      }
    })
  }

  private clickNo() {
    this.$emit("update:isShow", false);
  }
}
